import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LuGlobe } from 'react-icons/lu'
import { useLanguage } from 'contexts/LanguageContext'

const LANGUAGE_LABELS = { es: 'ES', ca: 'CA', en: 'EN' }

const VARIANT_CLASSES = {
  // Sobre fondo oscuro (p. ej. el panel azul del login)
  dark:  'border-white/30 text-white focus-within:ring-white/30',
  // Sobre fondo blanco (barra superior, login)
  light: 'border-gray-200 bg-white text-gray-700 focus-within:border-brand focus-within:ring-brand-soft',
}

export default function LanguageSelector({ variant }) {
  const { t } = useTranslation('layout')
  const { language, setLanguage, supportedLanguages } = useLanguage()

  return (
    <label className={`flex h-9 items-center gap-1.5 rounded-lg border pl-2.5 pr-1 text-sm font-medium focus-within:ring-4 ${VARIANT_CLASSES[variant]}`}>
      <LuGlobe size={16} aria-hidden="true" />
      <span className="sr-only">{t('language_selector.label')}</span>
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="h-full cursor-pointer bg-transparent pr-1 focus:outline-none"
      >
        {supportedLanguages.map((code) => (
          <option key={code} value={code} className="text-gray-800">
            {LANGUAGE_LABELS[code] || code.toUpperCase()}
          </option>
        ))}
      </select>
    </label>
  )
}

LanguageSelector.propTypes = {
  variant: PropTypes.oneOf(['dark', 'light'])
}

LanguageSelector.defaultProps = {
  variant: 'light'
}
